import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LinkComponent } from './site/link/link.component';
import { DownloadComponent } from './site/download/download.component';
import { CarnavalComponent } from './site/carnaval/carnaval.component';
import { TsAndCsComponent } from './site/legal/ts-and-cs/ts-and-cs.component';
import { PrivacyPolicyComponent } from './site/legal/privacy-policy/privacy-policy.component';
import { CookieComponent } from './site/legal/cookie/cookie.component';
import { EventComponent } from './site/event/event.component';
import { RootsComponent } from './site/roots/roots.component';

import mixpanel from "mixpanel-browser";

import { environment } from 'src/environments/environment';
import { VideoThumbComponent } from './site/roots/video-thumb/video-thumb.component';


mixpanel.init(environment.mixpanelToken, {
  debug: !environment.production,
  track_pageview: true,
  persistence: 'localStorage',
  autocapture: {
    pageview: "full-url",
    click: true,
    input: true,
    scroll: true,
    submit: true,
    capture_text_content: false,
  },
  record_sessions_percent: 1
});


@NgModule({
  declarations: [
    AppComponent,
    DownloadComponent,
    CarnavalComponent,
    LinkComponent,
    TsAndCsComponent,
    PrivacyPolicyComponent,
    CookieComponent,
    EventComponent,
    RootsComponent,
    VideoThumbComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
